import React, { useContext, useRef, useState, useEffect, useCallback } from 'react'
import './dialog.scss'

const DialogContext = React.createContext(() => {
})

export const DialogContextProvider = ({ children }) => {
  const modalRef = useRef()
  const [shownDialog, setShownDialog] = useState({
    dialog: null,
    parent: null,
    disableClose: false,
    modalStyle: null
  })
  const promise = useRef()

  const closeDialogHandler = useCallback((e) => {
    if (shownDialog.disableClose) {
      return
    }
    if (e.keyCode === 8 && e.target.nodeName !== 'INPUT' && e.target.nodeName !== 'TEXTAREA') {
      e.preventDefault()
    }

    if (e.keyCode === 27) {
      closeDialog()
    }
  }, [shownDialog.disableClose])

  useEffect(() => {
    if (!shownDialog.dialog) return
    if (shownDialog.disableClose) return
    document.addEventListener('keydown', closeDialogHandler)
    return () => {
      document.removeEventListener('keydown', closeDialogHandler)
    }
  }, [shownDialog])

  const setDialog = (dialog, triggerElement, disableClose) => {
    if (shownDialog.dialog === dialog) {
      return
    }

    setShownDialog({ dialog, style: (triggerElement ? { opacity: 0 } : {}), disableClose })

    if (triggerElement) {
      const parentBr = triggerElement.getBoundingClientRect()
      setTimeout(() => {
        const modalBr = modalRef.current.getBoundingClientRect()

        const x = (parentBr.left + parentBr.width / 2) - modalBr.left
        const y = (parentBr.top + parentBr.height / 2) - (modalBr.top + modalBr.height)
        setShownDialog(prevState => ({
          ...prevState,
          style: {
            opacity: 0,
            transform: `translate(${x}px, ${y}px) scale(0)`
          }
        }))

        setTimeout(() => {
          setShownDialog(prevState => ({
            ...prevState,
            style: {
              transition: 'transform 0.5s cubic-bezier(0.25, 0.8, 0.25, 1)',
              transformOrigin: '0 100%',
              opacity: 1,
              transform: 'translate(0, 0) scale(1)'
            }
          }))
        }, 100)
      })
    }
    return new Promise((res) => {
      promise.current = res
    })
  }

  const closeDialog = (props) => {
    setShownDialog({ dialog: null })
    promise.current(props)
    document.removeEventListener('keydown', closeDialogHandler)
  }

  const setDisableClose = useCallback( bool => {
    setShownDialog((prevState) => ({ ...prevState, disableClose: bool }))
  }, [setShownDialog])

  const content = shownDialog.dialog

  return (
    <DialogContext.Provider value={{setDialog, setDisableClose, closeDialog}}>
      {children}
      {content ? (
        <div className='Suc-dialog'>
          <div
            className='Suc-mask' onClick={shownDialog.disableClose ? () => {} : closeDialog}
          />
          <div className='Suc-modal' ref={modalRef} style={shownDialog.style}>
            {content}
          </div>
        </div>) : null}
    </DialogContext.Provider>

  )
}

export const useDialog = () => {
  return useContext(DialogContext)
}
